import { render, staticRenderFns } from "./publicWelfare.vue?vue&type=template&id=134bee12"
import script from "./publicWelfare.vue?vue&type=script&lang=js"
export * from "./publicWelfare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports